module.exports = __webpack_public_path__ + "media/images/avatar-gray-f396988ffcf0bd8f59879c413200ef78.png";